import { searchCommonConfig } from './common'

/**
 * FreeFic 品牌搜索页面配置
 */
export const searchConfig = {
  ...searchCommonConfig,
  colors: {
    inputBg: '#0000000A',
    startReadingBg: 'linear-gradient(315deg, #E65F3D 0%, #FFAD75 100%)',
  },
}
